let certificationsList=[
    {
        title:"Web Development BootCamp",
        instructor:"Angela Yu",
        link:"https://drive.google.com/file/d/1w4FPyEozyFhUO8CQgSoaG8-IlKqpzea8/view?usp=sharing",
        platform:'udemy'
    },
    {
        title:"React Js",
        instructor:"Maximilian Schwarzmuller",
        link:"#",
        platform:'udemy'
    },
    {
        title:"Node Js",
        instructor:"Maximilian Schwarzmuller",
        link:"#",
        platform:'udemy'
    },
    {
        title:"Flutter Development",
        instructor:"Maximilian Schwarzmuller",
        link:"https://drive.google.com/file/d/1iGTIn8QLcY1JCqWE-CCIWE5QP5c2cHZp/view?usp=sharing",
        platform:'udemy'
    },
];

const CertificatesData={certificationsList};
export default CertificatesData;